
import { timeOffsetCalculator } from '@/common/TimeOffsetCalculator';
import AnnexAlarmTimer from '@/pages/annex/alarms/AnnexAlarmTimer.vue';
import { applicationModule } from '@/store/application';
import { AnnexAlarm } from '@/thirdpaties/annex/annex.types';
import NIcon from '@/uikit/icons/NIcon.vue';
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({
  name: 'AnnexAlarmAcknowledgeInfo',
  components: { NIcon, AnnexAlarmTimer }
})
export default class AnnexAlarmAcknowledgeInfo extends Vue {
  @Prop({ type: Object, required: true })
  readonly item!: AnnexAlarm;

  @Prop({ type: Object, required: true })
  readonly adaptedItem!: any;

  get debug() {
    const { debug, presaleDebug } = applicationModule.settings;
    return debug || presaleDebug;
  }

  get serverTime() {
    return new Date(timeOffsetCalculator.getServerTime()).toISOString();
  }

  get timeFrom() {
    const currentTime = timeOffsetCalculator.getServerTime() / 1000;
    const createdTime = new Date(this.item.created_at).getTime() / 1000;
    const expiredTime = createdTime + Number(this.item.ack_interval);
    return Math.max(Math.round(expiredTime - currentTime), 0);
  }

  get acknowledgeMessage() {
    if (this.adaptedItem.acknowledge === 'in_work' || this.adaptedItem.acknowledge === 'cancel') {
      return this.$t('annex_alarms.ack_status.in_work') + this.item.ack_author;
    }
    if (this.adaptedItem.acknowledge === 'acknowledged') {
      return this.$t('annex_alarms.ack_status.acknowledged') + this.item.ack_author;
    }
    if (this.adaptedItem.acknowledge === 'auto_acknowledged') {
      return this.$t('annex_alarms.ack_status.auto_acknowledged');
    }
    return '';
  }

  timerFinished() {
    if (this.adaptedItem.acknowledge === 'none') {
      this.item.ack_value = 1;
    }
  }
}
